import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-calyrafit-text-with-icon';

const html = `
<div
  data-use-custom-width="false"
  data-custom-width="1204"
  class="container marquee-group"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div
    class="list-item"
    data-attribute="list-item"
    data-bg-wrapper="#FCF8F9"
    data-color-devider="#FFD0DB"
    style="--bg-wrapper: #FCF8F9; --color-devider: #FFD0DB"
  >
    <div data-attribute="item-text-with-icon" class="item-text-with-icon">
      <div class="wrap-icon">
        <img
          data-attribute="icon-item"
          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1faacd29a319cd74b93ae.png"
          alt=""
        />
      </div>
      <div data-attribute="text-item" class="text-item">
        <p>Worldwide <br> Shipping</p>
      </div>
    </div>
    <div data-attribute="item-text-with-icon" class="item-text-with-icon">
      <div class="wrap-icon">
        <img
          data-attribute="icon-item"
          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fab0d47777ea8cca5c95.png"
          alt=""
        />
      </div>
      <div data-attribute="text-item" class="text-item">
        <p>24/7 Customer<br>Support</p>
      </div>
    </div>
    <div data-attribute="item-text-with-icon" class="item-text-with-icon">
      <div class="wrap-icon">
        <img
          data-attribute="icon-item"
          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fab414b4fd31258986ce.png"
          alt=""
        />
      </div>
      <div data-attribute="text-item" class="text-item">
        <p>30-Day money back<br>guarantee</p>
      </div>
    </div>
    <div data-attribute="item-text-with-icon" class="item-text-with-icon">
      <div class="wrap-icon">
        <img
          data-attribute="icon-item"
          src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fab800d99960f3efc2ea.png"
          alt=""
        />
      </div>
      <div data-attribute="text-item" class="text-item">
        <p>Over 12,000 happy<br>customers</p>
      </div>
    </div>
  </div>
</div>

`;

export default containerFuild(html, css);
